export default {
    "favorites": "Favorites",
    "localization": "My location",
    "yourAccountMenu": "My account",
    "myProfile": "My profile",
    "loginText": "Login",
    "registerText": "Register",
    "loginTextMain": "Log in",
    "registerTextMain": "Register",
    "signOut": "Log out",
    "code": "Redeem Code",
    "mobileRegisterBanner": "Logged in save more"
}